import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ProspectoService } from '../../../../_services/prospecto.service';
import { forkJoin } from 'rxjs';
import { SolicitudEstadoHistoricoService } from '../../../../_services/solicitud-estado-historico.service';

@Component( {
  selector: 'app-widget-prospecto-perfil-actividad',
  templateUrl: 'widget-prospecto-perfil-actividad.component.html'
} )

export class WidgetProspectoPerfilActividadComponent implements OnInit {


  @Input()
  set idOficina( idOficina: string ) {
    this._idOficina = idOficina;
    if ( this._idOficina !== undefined ) {
      this.filtrar();
    }
  }

  get idOficina(): string {
    return this._idOficina;
  }

  @Input()
  set idAgrupacion( idAgrupacion: string ) {
    this._idAgrupacion = idAgrupacion;
    if ( this._idAgrupacion !== undefined ) {
      this.filtrar();
    }
  }

  get idAgrupacion(): string {
    return this._idAgrupacion;
  }

  @Input()
  set refrescar( refrescar: boolean ) {
    this._refrescar = refrescar;
    if ( this._refrescar ) {
      this.filtrar();
    }
  }

  get refrescar(): boolean {
    return this._refrescar;
  }

  _refrescar: boolean;

  _idAgrupacion: string;

  _idOficina: string;

  @Output() cargando: EventEmitter<boolean> = new EventEmitter();

  @Input() oficina: string;

  carDatos = false;

  prospectos = '';

  desembolsados = '';

  perfilados = '';


  constructor( private proServicio: ProspectoService,
               private solHistorialEstadoAnalizamos: SolicitudEstadoHistoricoService ) {
  }

  ngOnInit(): void {
  }

  filtrar() {
    this.carDatos = true;
    this.cargando.emit(true);
    forkJoin( this.proServicio.widgetContarProspectos( this._idAgrupacion, this._idOficina ),
      this.solHistorialEstadoAnalizamos.widgetContarPerfilamientos( this._idAgrupacion, this._idOficina, 'ESTPER' ),
      this.solHistorialEstadoAnalizamos.widgetContarPerfilamientos( this._idAgrupacion, this._idOficina, 'ESTDES' ) ).subscribe( ( [ conProspectos, conPerfilados, conDesembolsados ] ) => {
      this.prospectos = conProspectos;
      this.perfilados = conPerfilados;
      this.desembolsados = conDesembolsados;
      this.carDatos = false;
      this.cargando.emit(false);
    } );
  }


}
